<template>
  <div class="fixed-container">
    <div>
      <div v-if="isPasscodeType">
        <ItemButton label="トップページに戻る" @click="backToDbsIndexPage" />
      </div>
      <div v-else>
        <ItemButton
          v-if="!usingCycCsaName"
          label="QRコード読み取り"
          @click="openReadQr"
        />
        <ItemButton v-else label="鍵を開ける" @click="unlock" />
      </div>
    </div>
  </div>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" />

  <!-- 予約有効期限切れ時のダイアログ -->
  <DialogReservationExpired ref="DialogReservationExpired" />

  <!-- 開錠失敗のダイアログ -->
  <DialogUnlockingFailure ref="DialogUnlockingFailure" />
</template>

<script>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import API from "@/API";
import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DbsUnlockingBottomButtons",
  props: {
    isPasscodeType: {
      type: Boolean,
      required: true,
    },
    usingCycCsaName: {
      type: String,
      required: false,
      default: null,
    },
    isReserve: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const DialogReservationExpired = ref(null);
    const DialogUnlockingFailure = ref(null);

    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsIndexPage();
    };

    const goToIndexIfReservationStarted = async () => {
      const interval = setInterval(async () => {
        const isStarted = await dbsService.isStartedReservation();
        if (isStarted) {
          clearInterval(interval);
          // statusがstartedになったら、loadingを閉じてTOPヘ戻る
          DialogLoading.value.closeDialog();
          nativeHandlerService.returnNativeDbsIndexPage();
        }
      }, 1000);
    };

    const openReadQr = async () => {
      try {
        DialogLoading.value.openDialog();
        // 予約期限切れの場合
        if (await dbsService.isExpiredReservation()) {
          DialogLoading.value.closeDialog();
          DialogReservationExpired.value.openDialog();
        } else {
          DialogLoading.value.closeDialog();
          if (props.isReserve) {
            nativeHandlerService.ncDbsQrFromReserve();
          } else {
            nativeHandlerService.ncDbsQrFromUsing();
          }
        }
      } catch (e) {
        DialogLoading.value.closeDialog();
        console.log("Error in DbsUnlockingBottomButtons.openReadQr()", e);
      }
    };

    const unlock = async () => {
      try {
        DialogLoading.value.openDialog();
        // 予約期限切れの場合
        if (await dbsService.isExpiredReservation()) {
          DialogLoading.value.closeDialog();
          DialogReservationExpired.value.openDialog();
        } else {
          const params = {
            cyc_csa_choice: "1",
            cyc_csa_name: props.usingCycCsaName,
          };

          await API.postDbsUnlock(params);

          if (props.isReserve) {
            // 予約statusの反映にタイムラグがあるので、status変更を待ってからTOPへ戻す
            await goToIndexIfReservationStarted();
          } else {
            DialogLoading.value.closeDialog();
          }
        }
      } catch (e) {
        DialogLoading.value.closeDialog();
        DialogUnlockingFailure.value.openDialog(e.response.data.error);
        console.log("Error in DbsUnlockingBottomButtons.unlock()", e);
      }
    };

    return {
      DialogLoading,
      DialogReservationExpired,
      DialogUnlockingFailure,
      backToDbsIndexPage,
      openReadQr,
      unlock,
    };
  },
};
</script>
<style scoped>
.fixed-container {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffffff;
}

.fixed-container div {
  width: 95%;
  margin: auto;
}

.fixed-container button {
  width: 100%;
  height: 46px;
  border: none;
  background-color: #ffb206;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  box-shadow: var(--defaultBoxShadow);
}
</style>
